// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9b3601ec","732":"c80e1703","977":"a2c95cc5"}[chunkId] + ".chunk.js";
};